import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { faSave } from "@fortawesome/free-regular-svg-icons";
import { faEdit, faPlusCircle, faTimes, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { TranslateService } from "@ngx-translate/core";
import { SwalModalService } from "app/core/services/global/modal/modal.service";
import { ElementTypeService } from "app/core/services/pim/element-type.service";
import { ElementService } from "app/core/services/pim/element.service";
import { ListCascadeService } from "app/core/services/pim/listcascade.service";
import { TreeDragDropService } from "primeng-lts/api";
declare var jQuery: any;

@Component({
    selector: "app-listcascade-update",
    templateUrl: "./listcascade-update.component.html",
    providers: [TreeDragDropService],
})
export class ListCascadeUpdateComponent implements OnInit {
    list: any = [];
    selectedValue: any = null;
    selectedValues: any[] = [];
    lastId: number = 0;
    elementsSeparator: "";
    chips: string[] = [];
    name: string = "";
    currentValue: string = "";
    changeList = false;
    updateName = false;
    infoAddValue = "";
    versions = [];
    dataModels = [];
    products = [];
    model = null;
    product = null;
    parentProduct = null;
    currentLabel: string = "";

    readonly faSave = faSave;
    readonly faPlus = faPlusCircle;
    readonly faTrashAlt = faTrashAlt;
    readonly faEdit = faEdit;
    readonly faClose = faTimes;

    @ViewChild("createModal", { static: false }) createModal: ElementRef;
    @ViewChild("updateModal", { static: false }) updateModal: ElementRef;

    constructor(
        private _swalModalService: SwalModalService,
        private _listcascadeService: ListCascadeService,
        private _router: Router,
        private _translate: TranslateService,
        private _route: ActivatedRoute,
        private _elementTypeService: ElementTypeService,
        private _elementService: ElementService
    ) {}
    ngOnInit(): void {
        this.name = this._route.snapshot.data.list.name;
        this.list = this._route.snapshot.data.list.listValues ?? [];
        this.lastId = this._route.snapshot.data.list.lastId;
        this.model = this._route.snapshot.data.list.model;

        this.infoAddValue = this._translate.instant("general.addNewValueEnter");

        this._elementTypeService.getElementTypes().subscribe((res: any) => {
            this.dataModels = res.data;
        });

        if (this.model) {
            this._elementService.getElementsByModelAndVersion(this.model, 1).subscribe((res: any) => {
                this.products = res.data;
            });
        }
    }

    onSelect(event) {
        this.selectedValues = [];

        this.selectedValues.push(event.node);
        this.selectedValue = event.node;
        this.currentValue = event.node.name;
        this.parentProduct = event.node.product;
        this.currentLabel = event.node.tag;
    }

    onUnselect() {
        this.selectedValue = null;
        this.currentValue = "";
        this.parentProduct = null;
        this.currentLabel = "";
    }

    addValue() {
        if (this.chips.length) {
            this.changeList = true;
            this.chips.forEach((chip) => {
                let chipLabel = this.product ? chip + " 🔗" : chip;
                chipLabel = this.currentLabel ? chipLabel + " " + this.currentLabel : chipLabel;
                this.lastId = this.lastId + 1;
                if (this.selectedValue == null) {
                    this.list.push({
                        children: null,
                        id: this.lastId,
                        key: this.lastId,
                        label: chipLabel,
                        name: chip,
                        parent: null,
                        selected: false,
                        product: this.product ? this.product : null,
                        tag: this.currentLabel,
                    });
                } else {
                    if (this.selectedValue.children == null) {
                        this.selectedValue.children = [];
                    }
                    this.selectedValue.children.push({
                        children: null,
                        id: this.lastId,
                        key: this.lastId,
                        label: chipLabel,
                        name: chip,
                        parent: this.selectedValue,
                        selected: false,
                        product: this.product ? this.product : null,
                        tag: this.currentLabel,
                    });
                }
            });
        }
        this.chips = [];
        this.product = null;
        this.currentLabel = "";
        jQuery(this.createModal.nativeElement).modal("hide");
    }

    updateValue() {
        this.selectedValue.name = this.currentValue;
        this.selectedValue.label = this.parentProduct ? this.currentValue + " 🔗" : this.currentValue;
        this.selectedValue.label = this.currentLabel ? this.selectedValue.label + " " + this.currentLabel : this.selectedValue.label;
        this.selectedValue.product = this.parentProduct && this.parentProduct != "" ? +this.parentProduct : null;
        this.selectedValue.tag = this.currentLabel;
        jQuery(this.updateModal.nativeElement).modal("hide");
    }

    /**
     * Open create modal
     */
    openCreateModal() {
        jQuery(this.createModal.nativeElement).modal("show");
    }

    /**
     * Open create modal
     */
    openUpdateModal() {
        jQuery(this.updateModal.nativeElement).modal("show");
    }

    saveList() {
        let newList = this.fixRecursive(this.list);
        this._listcascadeService.updateListCascade(this._route.params["_value"].id, newList, this.lastId, this.name, this.model).subscribe((data) => {});
    }

    fixRecursive(list) {
        list.forEach((value) => {
            value.parent = null;
            if (value.children && value.children.length > 0) {
                this.fixRecursive(value.children);
            }
        });

        return list;
    }

    deleteValue() {
        this._swalModalService.delete().then((result) => {
            if (result.isConfirmed) {
                if (this.selectedValue.parent) {
                    let parent = this.selectedValue.parent;
                    let index = parent.children.map((child) => child.id).indexOf(this.selectedValue.id);
                    parent.children.splice(index, 1);
                } else {
                    let index = this.list.map((value) => value.id).indexOf(this.selectedValue.id);
                    this.list.splice(index, 1);
                }
                this.onUnselect();
            }
        });
    }

    saveName(newName) {
        this.changeList = true;
        this.name = newName;
    }

    expandCollapse(action) {
        this.list.forEach((node) => {
            if (action == "expand") {
                this.expandRecursive(node, true);
            } else {
                this.expandRecursive(node, false);
            }
        });
    }

    private expandRecursive(node, isExpand: boolean) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach((childNode) => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    // loadProducts(event) {
    //     if (event != this.model) {
    //         this.resetProduct(this.list);
    //         this.model = event;
    //         if (event) {
    //             this._elementService.getElementsByModelAndVersion(event, 1).subscribe((res: any) => {
    //                 this.products = res.data;
    //             });
    //         }
    //     }
    // }

    setProduct(event, parent: boolean = false) {
        if (parent) {
            this.parentProduct = event ?? null;
        } else {
            this.product = event ?? null;
        }
    }

    // resetProduct(list) {
    //     list.forEach((value) => {
    //         value.product = null;
    //         if (value.children && value.children.length > 0) {
    //             this.fixRecursive(value.children);
    //         }
    //     });
    // }
}
